<script lang="ts">
  export let title;
  export let position;
  export let onClick;
</script>

{#if position}
  <div data-lat={position.lat} data-lng={position.lng} on:click={onClick}>
    {title}
  </div>
{/if}
